/*
//- Example setup as to how have to setup each gallery item
//- In order for the LightGallery to work the following
//- things must be present in the DOM elements:
//-     - `a` with `href={image url}` & class "gallery-item"
//-     - If we want captions, add data attribute: `data-sub-html`
//-     - HTML `img` as a child of the "link" (if we want to show the image in the dialog before opening)
*/

const WorkOrdersTemporaryLightGallery = {
  _$el: null,
  _onToggleCallback: null,
  _itemSelector: '.gallery-item',

  initialize(element, onToggleCallback) {
    const $el = $(element);

    // Destroy possible existing galleries
    this.destroy();

    this._$el = $el;
    this._onToggleCallback = onToggleCallback;

    this._$el
      .lightGallery({
        selector: this._itemSelector,
        thumbnail: true,
        showThumbByDefault: false,
        hideControlOnEnd: true,
        download: false,
        fullscreen: false,
        actualSize: false,
        zoom: false,
        preload: 3,
        allowHtmlCaptions: true,
        allowCaptionLookups: false,
        getCaptionsFromTitleOrAlt: false,
      })
      .on('onAfterOpen.lg', () => {
        // Necessary to avoid backdrop flickering in AppDialog.vue
        // The reason for 150, is the ms delay until backdrop transitions
        // into the DOM animating.
        setTimeout(() => this._onToggleCallback(true), 150);
      })
      .on('onBeforeClose.lg', () => this._onToggleCallback(false));
  },

  destroy() {
    if (this._$el && this._$el.data('lightGallery')) {
      this._$el.off('onAfterOpen.lg').off('onBeforeClose.lg');
      this._$el.data('lightGallery').destroy(true);
      this._$el = null;
    }

    if (this._onToggleCallback) {
      this._onToggleCallback = null;
    }
  },
};

export default WorkOrdersTemporaryLightGallery;
